// Import screenshots directly as modules for instant loading
import screenshot1 from '../images/screenshots/screenshot-1.png';
import screenshot2 from '../images/screenshots/screenshot-2.png';
import screenshot3 from '../images/screenshots/screenshot-3.png';
import screenshot4 from '../images/screenshots/screenshot-4.png';
import screenshot5 from '../images/screenshots/screenshot-5.png';
import screenshot6 from '../images/screenshots/screenshot-6.png';
import screenshot7 from '../images/screenshots/screenshot-7.png';
import screenshot8 from '../images/screenshots/screenshot-8.png';

export const APP_CONFIG = {
  name: 'Subwise',
  tagline: 'Take control of your subscriptions',
  supportEmail: 'subwise.support@mutarelabs.com',
  appStoreUrl: 'https://apps.apple.com/us/app/subwise-subscription-tracker/id6741874006',
  company: 'Mutare Labs',
  currentYear: new Date().getFullYear(),
  version: '1.0.0',
};

export const NAVIGATION_TABS = [
  { id: 'home', label: 'Home', path: '/' },
  { id: 'support', label: 'Support', path: '/support' },
  { id: 'contact', label: 'Contact', path: '/contact' },
];

export const HERO_FEATURES = [
  {
    id: 1,
    text: 'Take complete control of your subscription spending with intelligent tracking and analytics'
  },
  {
    id: 2,
    text: 'Get detailed insights into your monthly expenses across all categories'
  },
  {
    id: 3,
    text: 'Receive smart notifications before renewals to help you make informed decisions'
  }
];

export const CAROUSEL_CONFIG = {
  autoAdvanceInterval: 4000,
  transitionDuration: 500,
  pauseOnHover: true,
  resumeAfterInteraction: 5000,
};

export const FORM_CONFIG = {
  validation: {
    minNameLength: 2,
    minSubjectLength: 5,
    minMessageLength: 10,
    maxNameLength: 100,
    maxSubjectLength: 200,
    maxMessageLength: 1000,
  },
  placeholders: {
    name: 'Your full name',
    subject: 'What is this about?',
    message: 'Tell us more about your inquiry...',
  },
};

export const BREAKPOINTS = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

// Direct imports - available instantly, no network requests needed
export const SCREENSHOT_DATA = {
  images: [
    screenshot1,
    screenshot2,
    screenshot3,
    screenshot4,
    screenshot5,
    screenshot6,
    screenshot7,
    screenshot8
  ],
};